<template>
  <div id="country-flag">
    <template v-if="flagSrc">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <img v-bind="attrs" :src="flagSrc" :width="width" v-on="on" />
        </template>
        <span v-if="country">
          {{ $t('views.stocks.stockTable.country') }}:
          {{ $te(`common.countries.${country}`) ? $t(`common.countries.${country}`) : country }}
          <br />
        </span>
        <span v-if="exchange">
          {{ $t('common.exchange') }}:
          {{ $t(`common.exchanges.${country}.${exchange}`) }}
          <br />
        </span>
        <span v-if="legalCountry">
          {{ $t('views.stocks.stockTable.legalCountry') }}:
          {{
            $te(`common.countries.${legalCountry}`)
              ? $t(`common.countries.${legalCountry}`)
              : legalCountry
          }}
          <br />
        </span>
        <span v-if="exposureCountry">
          {{ $t('views.stocks.stockTable.exposureCountry') }}:
          {{
            $te(`common.countries.${exposureCountry}`)
              ? $t(`common.countries.${exposureCountry}`)
              : exposureCountry
          }}
        </span>
      </v-tooltip>
    </template>
    <span v-else-if="country === 'FX'">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" :size="width + 1" class="country-flag-cash-icon" v-on="on">
            mdi-wallet
          </v-icon>
        </template>
        <span>{{ $t(`common.countries.${country}`) }}</span>
      </v-tooltip>
    </span>
    <span v-else-if="country === 'CC'">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" :size="width + 2" class="country-flag-crypto-icon" v-on="on">
            mdi-bitcoin
          </v-icon>
        </template>
        <span>{{ $t(`common.countries.${country}`) }}</span>
      </v-tooltip>
    </span>
    <span v-else-if="country === 'INDEX'">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" :size="width + 2" class="country-flag-index-icon" v-on="on">
            mdi-chart-line-variant
          </v-icon>
        </template>
        <span>{{ $t(`common.countries.${country}`) }}</span>
      </v-tooltip>
    </span>
    <span v-else-if="country === 'COMM'">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" :size="width + 2" class="country-flag-commodity-icon" v-on="on">
            mdi-gold
          </v-icon>
        </template>
        <span>{{ $t(`common.countries.${country}`) }}</span>
      </v-tooltip>
    </span>
    <span v-else-if="country" class="country-flag-text">
      {{ country }}
    </span>
    <span v-else-if="type === 'custom'">
      <v-icon class="country-flag-custom-icon">mdi-list-box</v-icon>
    </span>
    <span v-else>
      <v-icon class="country-flag-no-flag-icon" :size="width">
        mdi-diving-scuba-flag
      </v-icon>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: null,
    },
    country: {
      type: String,
      default: null,
    },
    legalCountry: {
      type: String,
      default: null,
    },
    exposureCountry: {
      type: String,
      default: null,
    },
    exchange: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    flagSrc() {
      const tryFlag = (code) => {
        if (!code) return null
        try {
          return require(`@/assets/country/${code.toLowerCase()}.png`)
        } catch {
          return null
        }
      }
      if (this.country) {
        return tryFlag(this.country)
      }
      if (this.legalCountry) {
        return tryFlag(this.legalCountry)
      }
      return tryFlag(this.exposureCountry)
    },
  },
}
</script>

<style>
.country-flag-text {
  font-size: 14px;
  font-weight: 500;
}
.country-flag-no-flag-icon {
  padding-bottom: 2px;
  margin-right: 5px;
}
.country-flag-cash-icon {
  padding-bottom: 2px;
}
.country-flag-crypto-icon {
  padding-bottom: 1px;
}
.country-flag-index-icon {
  padding-bottom: 1px;
  margin-right: 3px;
}
.country-flag-commodity-icon {
  padding-bottom: 1px;
}
.country-flag-custom-icon {
  padding-bottom: 1px;
  margin-right: 3px;
}
</style>
